// JavaScript Document

jQuery(document).ready(function($){
	if ( $(window).width() < 767) {  
	
	$( "#footer-widgets aside>div" ).hide();

	$( "#footer-widgets aside .widget-title" ).attr("aria-expanded","false");
	$( "#footer-widgets aside .widget-title" ).attr("role","button");


	$( "#footer-widgets aside .widget-title" ).click( function() {
		$(this).toggleClass( "active" ).next().toggle();

		if($(this).hasClass("active")){
			$( this ).attr("aria-expanded","true");
		}else{
			$( this ).attr("aria-expanded","false");
		}

		return false;
	} );
	}
	
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();

    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 600) {


			jQuery( function( $ ) {
				$( document ).ready(function() {
					if ($.fn.slick){
					$('.hp-image-boxes .elementor-row').slick({
						
						rtl:true,
						nextArrow: '<i class="fa fa-angle-right"></i>',
						prevArrow: '<i class="fa fa-angle-left"></i>',
					});
					} //end if slick
					
				} );
			} ); //2nd jQuery function		
			
		}
	}
});


function a11yClick(event){

    
  
    if(event.type === 'click'){
        
        return true;
    } else if(event.type === 'keypress'){
       
        var code = event.charCode || event.keyCode;
        if(code === 32){
                event.preventDefault(); // don't scroll the page
        }
        
        if((code === 32) || (code === 13)){
            return true;
        }
    }else{
        //console.log ('a11yClick false');
        return false;
    }
}


/**
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
 ( function() {
	var isWebkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
	    isOpera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
	    isIe     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

	if ( ( isWebkit || isOpera || isIe ) && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();
			}
		}, false );
	}
})();


